import React from 'react';
import { Toolbar } from '@mui/material';
import Header from './header.component';
import Footer from './footer.component';
import { ChatBot } from '../chatbot';

const Layout = ({ children, mode, toggleTheme }) => {
    return (
        <>
            <Header mode={mode} toggleTheme={toggleTheme} />
            <Toolbar /> {/* Spacer for fixed AppBar */}
            <main>{children}</main>
            <Footer mode={mode} toggleTheme={toggleTheme} />
            {/* Chatbot component will be fixed to bottom right */}
            {/* <ChatBot mode={mode} /> */}
        </>
    );
};

export default Layout;